import styled from 'styled-components';

const LogoText = styled.h1`
  font-size: 92px;
  font-family: 'Space Mono', monospace;
  font-weight: 600;
  margin: 10px 0;
  color: #bfc9ca;
`;

export default LogoText;
